import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

export const TopMenu = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
          Home Jef
        </Typography>
        <Button color="inherit" onClick={() => navigate("/profile")}>Profile</Button>
        <Button color="inherit" onClick={() => navigate("/security")}>Security</Button>
        {auth.isAuthenticated ? (
          <Button color="inherit" onClick={() => auth.removeUser()}>Logout</Button>
        ) : (
          <Button color="inherit" onClick={() => auth.signinRedirect()}>Login</Button>
        )}
      </Toolbar>
    </AppBar>
  );
};
